// Restored from production OTA 2026-08-21 (module 1342).
//
// The file this replaced was a Firebase v8 template that never exported `api`,
// although 47 screens import it, and wrapped each action as
// fn()(dispatch)(firebase) - which throws for actions that are not curried.
// Every action module now imports `firebase` itself, so `api` is simply all of
// them spread together.
import { FirebaseContext, FirebaseProvider, firebase } from './config/configureFirebase';
import store from './store/store';

import * as authactions from './actions/authactions';
import * as bookingactions from './actions/bookingactions';
import * as bookinglistactions from './actions/bookinglistactions';
import * as cancelreasonactions from './actions/cancelreasonactions';
import * as cartypeactions from './actions/cartypeactions';
import * as estimateactions from './actions/estimateactions';
import * as driverearningaction from './actions/driverearningaction';
import * as earningreportsaction from './actions/earningreportsaction';
import * as notificationactions from './actions/notificationactions';
import * as promoactions from './actions/promoactions';
import * as usersactions from './actions/usersactions';
import * as settingsactions from './actions/settingsactions';
import * as paymentactions from './actions/paymentactions';
import * as tripactions from './actions/tripactions';
import * as taskactions from './actions/taskactions';
import * as locationactions from './actions/locationactions';
import * as chatactions from './actions/chatactions';
import * as withdrawactions from './actions/withdrawactions';
import * as DateFunctions from './other/DateFunctions';
import * as GoogleAPIFunctions from './other/GoogleAPIFunctions';
import * as GeoFunctions from './other/GeoFunctions';
import * as languageactions from './actions/languageactions';
import * as addressactions from './actions/addressactions';
import * as NotificationFunctions from './other/NotificationFunctions';
import * as caractions from './actions/caractions';
import * as smtpactions from './actions/smtpactions';
import * as smsactions from './actions/smsactions';
import { countries } from './other/GetCountries';
import * as sosactions from './actions/sosactions';
import * as complainactions from './actions/complainactions';
import {
    normalizeCountry,
    isTanzaniaCountry,
    isSupportedCountry,
    CANONICAL_COUNTRIES
} from './other/CountryFunctions';

// Same order as production: a later module wins a name clash, so
// paymentactions.addToWallet (a thunk) replaces authactions.addToWallet.
const api = {
    ...authactions,
    ...bookingactions,
    ...bookinglistactions,
    ...cancelreasonactions,
    ...cartypeactions,
    ...estimateactions,
    ...driverearningaction,
    ...earningreportsaction,
    ...notificationactions,
    ...promoactions,
    ...usersactions,
    ...settingsactions,
    ...paymentactions,
    ...tripactions,
    ...taskactions,
    ...locationactions,
    ...chatactions,
    ...withdrawactions,
    ...DateFunctions,
    ...GoogleAPIFunctions,
    ...GeoFunctions,
    ...languageactions,
    ...addressactions,
    ...NotificationFunctions,
    ...caractions,
    ...smtpactions,
    ...smsactions,
    ...sosactions,
    ...complainactions,
    countries,
    // Firebase ID token for the endpoints that authenticate the caller
    // (get_providers_v2, pawapay-activation, pawapay-disburse, transfer_wallet).
    getIdToken: () =>
        firebase.auth && firebase.auth.currentUser
            ? firebase.auth.currentUser.getIdToken()
            : Promise.reject(new Error('NOT_SIGNED_IN')),
};

export {
    FirebaseContext,
    FirebaseProvider,
    store,
    api,
    normalizeCountry,
    isTanzaniaCountry,
    isSupportedCountry,
    CANONICAL_COUNTRIES
};
